import React from 'react'
import { Input, Label } from 'components';

import ReactTooltip from 'react-tooltip'
import styles from './Steps.scss';


const Steps = (props) => {
  let classNames = styles.steps + ' ' + styles['steps-'+props.val.length]
  if(props.theme == 'light'){
    classNames = classNames + ' ' + styles.isLight
  }


  let tmpActive = true;
  let stepNames = props.val.map(function(step, index){
    if(tmpActive){
      let activeClass = styles.stepsBefore;
      if(step.active){
        tmpActive = false;
        activeClass = styles.stepsActive;
      }

      return <div key={index} className={activeClass}>{step.name}</div>
    }else{
      return <div key={index} >{step.name}</div>
    }
  })

  let tmpActive2 = true;
  let stepLines = props.val.map(function(step, index){
    
    if(tmpActive2){
      if(step.active){
        tmpActive2 = false;
      }
      return <div key={index}></div>;
    }
  })


  return (
    <div className={styles.wrapper}>
      <div className={classNames}>{stepNames}</div>
      <div className={styles.stepLine}>
        <div className={styles.lineActive + ' ' + styles['lineActive-'+props.val.length]}>
          {stepLines}
        </div>
      </div>
    </div>
  )
}

export default Steps



// WEBPACK FOOTER //
// ./src/components/molecules/Steps/index.js